<template>
<div>
	<div class="infomationTable">
		<table class="table">
		    <tr>
			    <th>序号</th>
			    <th>执业资格名称</th>
			    <th>执业资格专业</th>
			    <th>注册号（职业印章号）</th>
			    <th>注册有效期</th>
			    <th>注册关系是否转入</th>
			    <th>附件</th>
			    <th>操作</th>
		    </tr>
		    <tr v-for="(item,index) in formList">
		        <td>
		        	<div class="label">序号</div>
		        	{{index+1}}
		        </td>
		        <td>
		        	<div class="label">执业资格名称</div>
		        	{{item.name}}
		        </td>
		        <td>
		        	<div class="label">执业资格专业</div>
		        	{{item.major}}
		        </td>
		        <td>
		        	<div class="label">注册号（职业印章号）</div>
		        	{{item.sealNumber}}
		        </td>
		         <td>
		        	<div class="label">注册有效期</div>
		        	{{item.duration}}
		        </td>
		         <td>
		        	<div class="label">注册关系是否转入</div>
		        	{{item.transfer}}
		        </td>
		        <td>
		        	<div class="label">附件</div>
		        	<div class="fjName" :title="item.file">{{item.file}}</div>
		        </td>
		      	<td>
		      		<div class="label">操作</div>
		      		<div class="edit" @click="edit(item.id)">编辑</div>
		      	</td>
		    </tr>
		</table>
	</div>
	
	<!-- 添加按钮 -->
	<div class="addBtn" @click="add"></div>
	
	<!-- 编辑、新增的弹窗 -->
	<div class="infomationAddEdit" v-if="popShow">
		<div class="mask"></div>
		<div class="form">
			<div class="close" @click="cancel"></div>
			<div class="tit f-16 fb">
				<template v-if="addOrEdit==1">
					新增
				</template>
				<template v-if="addOrEdit==2">
					编辑
				</template>	
			</div>
			<div class="item cf">
	        	<div class="name fl"><span>*</span>执业资格名称</div>
	        	<div class="ovh text">
					<input type="text" v-model="popData.name" name="name" placeholder="请填写执业资格名称">
				</div>
			</div>
			<div class="item cf">
	        	<div class="name fl"><span>*</span>执业资格专业</div>
	        	<div class="ovh text">
	        		<input type="text" v-model="popData.major" name="major" placeholder="请填写执业资格专业">
				</div>
			</div>
			<div class="item cf">
	        	<div class="name fl"><span>*</span>注册号（职业印章号）</div>
	        	<div class="ovh text">
	        		<input type="text" v-model="popData.sealNumber" name="sealNumber" placeholder="请填写注册号（职业印章号）">
				</div>
			</div>
	        <div class="item cf">
	        	<div class="name fl"><span>*</span>注册有效期</div>
	        	<div class="ovh text">
	        		<el-date-picker
			            v-model="popData.duration"
			            value-format="yyyy-MM-dd"
			            placeholder="请选择注册有效期">
			        </el-date-picker>
				</div>
			</div>
			<div class="item cf">
	        	<div class="name fl"><span>*</span>注册关系是否转入</div>
	        	<div class="ovh text">
	        		<input type="text" v-model="popData.transfer" name="transfer" placeholder="请填写注册关系是否转入">
				</div>
			</div>
			<div class="item cf">
	        	<div class="name fl"><span>*</span>上传附件</div>
	        	<div class="ovh">
	        		<el-upload
			          class="upload-demo"
			          :action="uploadFileUrl"
			          :headers="headers"
			          :show-file-list="true"
			          :on-success="(res,file)=>{return handleSuccess(res,file)}"
			          :on-remove="(res,file)=>{return handleRemove(res,file)}"
			          :multiple="false"
			          :file-list="popData.file"
			          :before-upload="uploadFun">
			            <span class="fileInput" v-if="popData.file==''||popData.file==null">点击上传</span>
			        </el-upload>
				</div>
			</div>

	      	<div class="btnBox">
				<div class="btn btn1" @click="save">保存</div>
				<div class="btn btn2" @click="cancel">取消</div>
	      	</div>
		</div>
	</div>
</div>
</template>
<script>
import { urlHead } from '@/utils/http'
import { 
  requirementsList,
  requirementsAdd,
  requirementsEdit,
  requirementsDelete,
  requirementsQueryById
} from "@/api/tableapi";

export default {
	name: 'tablerequirements',
	props:{
		isshow: {
	      	type: Boolean,
  			default: {}
	    }
	},
	watch: {
	    isshow: {
	      immediate: true,
	      handler(newval,oldval) {
	        if (newval) {
	        	this.initData()
	        }
	      }
	    },
	},
	data(){
		return{
			uploadFileUrl:urlHead+'user-api/common/upload',
		    headers: {
		       'X-Access-Token':window.sessionStorage.getItem('token'), //headers属性中添加token，这个属性是el-upload自带的用来设置上传请求头部
		    },
		    formList:[],
		    addOrEdit:1,   //1是新增2是编辑
		    popData:{
		    	name:'',
		    	major:'',
		    	sealNumber:'',
		    	duration:'',
		    	transfer:'',
		    	file:[]
		    },
		    popShow:false,
		}
	},
	created(){
		this.initData()
	},
  	methods:{
  		//获取当前表格的数据
  		initData(){
  			let that=this
  			requirementsList("").then(res=>{
              if (res.success) {
              	let list=res.result.records
              	list.forEach((item,index)=>{
              		if(item.file!=''&&item.file!=null){
	              		let nameArr=item.file.split("/")
			          	let ind = nameArr.length - 1
			          	item.file=nameArr[ind]	
		          	}
              	})                
                that.formList=list
              }
            })
        },

        //添加
	    add(){
	    	let that=this
	    	that.addOrEdit=1
	    	that.popData={
		    	name:'',
		    	major:'',
		    	sealNumber:'',
		    	duration:'',
		    	transfer:'',
		    	file:[]
		    }

		    that.popShow=true
	    },

	    //编辑
	    edit(id){
	    	let that=this
	    	requirementsQueryById(id).then(res=>{
		        //console.log(res)
		        if(res.success){
		          that.addOrEdit=2
		          if (res.result.file==null||res.result.file=='') {
		          	res.result.file=[]
		          }else{
		          	let nameArr=res.result.file.split("/")
		          	let ind = nameArr.length - 1
		          	res.result.file=[{
		          		name: nameArr[ind], 
		          		url: res.file
		          	}]
		          }

		          if(res.result.duration!=''&&res.result.duration!=null){
		            let duration=res.result.duration
		            res.result.duration=duration.split(" ")[0]
		          }

		          that.popData=res.result
		          that.popShow=true
		        }else{
		          that.$message.error(res.message)
		          return false
		        }
		    })
	    },

	    handleSuccess(res,file) {
		    let that=this
		    that.popData.file=[{name:file.name, url:res.result}]
	    },
	    //移除
	    handleRemove(res,file) { 
	    	let that=this
	    	that.popData.file=[]
	    },

	    //上传前格式校验
	    uploadFun(file){
	      let that=this
	      //console.log(file.type,"file.type")
	      const isJPG = file.type === 'image/jpeg' || file.type==='image/png' || file.type==='image/jpg' || file.type==='application/pdf' || file.type === 'application/vnd.ms-excel' || file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type === 'application/msword' || file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || file.type === 'application/vnd.ms-powerpoint' || file.type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
	      const isLt50M = file.size / 1024 / 1024 < 50;
	      //word excel ppt
	      if (!isJPG) {
	        that.$message.error('只能上传pdf、图片、word、excel、ppt!');
	      }
	      if (!isLt50M) {
	        that.$message.error('上传头像图片大小不能超过 50MB!');
	      }
	      return isJPG && isLt50M;
	    },

	    save(){
	    	let that=this

		    //验证，表格结构数据中有必填和校验正则
		    if (that.popData.name==''||that.popData.name==null) {
		    	that.$message.error('请填写执业资格名称！');
		    	return false
		    }
		    if (that.popData.major==''||that.popData.major==null) {
		    	that.$message.error('请填写执业资格专业！');
		    	return false
		    }
		    if (that.popData.sealNumber==''||that.popData.sealNumber==null) {
		    	that.$message.error('请填写注册号（职业印章号）！');
		    	return false
		    }

		    if (that.popData.duration==''||that.popData.duration==null) {
		    	that.$message.error('请选择注册有效期 ！');
		    	return false
		    }
		    if (that.popData.transfer==''||that.popData.transfer==null) {
		    	that.$message.error('请填写注册关系是否转入！');
		    	return false
		    }

		    if (that.popData.file==''||that.popData.file==null) {
		    	that.$message.error('请上传附件!');
		    	return false
		    }

		    //通过验证
		    that.popData.duration += " 00:00:00"

		   	let popData={...that.popData}
		    
		    if(popData.file!=''&&popData.file!=null){
		    	popData.file=popData.file[0].url
		    }else{
		    	popData.file=""
		    }

		    //添加
		    if (that.addOrEdit==1) {
		    	requirementsAdd(popData).then(res=>{
	              if (res.success) {
	              	that.initData()            
	                that.$message.success('添加成功');
	                that.popShow=false
	              }else{
	              	that.$message.error(res.message);
	              }
	            })
		    }
		    //编辑
		    if (that.addOrEdit==2) {
		    	requirementsEdit(popData).then(res=>{
	              if (res.success) { 
	              	that.initData()              
	                that.$message.success('编辑成功');
	                that.popShow=false
	              }else{
	              	that.$message.error(res.message);
	              }
	            })
		    }
	    },

	    cancel(){
	    	let that=this
	    	that.popShow=false
	    }
  	}
}
</script>





// WEBPACK FOOTER //
// src/components/global/tablerequirements/index.vue